import { render, staticRenderFns } from "./MetricCircle.vue?vue&type=template&id=304352d4&scoped=true"
import script from "./MetricCircle.vue?vue&type=script&lang=ts"
export * from "./MetricCircle.vue?vue&type=script&lang=ts"
import style0 from "./MetricCircle.vue?vue&type=style&index=0&id=304352d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304352d4",
  null
  
)

export default component.exports